import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@project/env/environment';

@Injectable({
  providedIn: 'root'
})
export class SearchService {

  private baseUrl = `${environment.baseUrl}`;
  searchedDiscipline: any;

  constructor(private http: HttpClient) {
    this.baseUrl = `${environment.serverUrl}${this.baseUrl}`;
  }

  getProjectLocations() {
    return this.http.get(this.baseUrl + 'countries/?project=True');
  }

  getProjectDisciplines() {
    return this.http.get(this.baseUrl + 'super_tags/all_disciplines/');
  }

  getProjectTags() {
    return this.http.get(this.baseUrl + 'tags/?title=&project=True');
  }

  getProjectStatusTags() {
    return this.http.get(this.baseUrl + 'tags/?type=Project Status');
  }

  getProjectScaleTags() {
    return this.http.get(this.baseUrl + 'tags/?type=Project Scale');
  }

  getProjectMaterialTags() {
    return this.http.get(this.baseUrl + 'tags/?type=Material');
  }

  getProjectYearOfConstTags() {
    return this.http.get(this.baseUrl + 'tags/?type=Year of construction');
  }

  setSearchDiscipline(discipline) {
    this.searchedDiscipline = discipline;
  }

  getSearchDiscipline() {
    return this.searchedDiscipline;
  }

  getFilteredProjects(
    page: number,
    search_text: string,
    username: string,
    discipline_ids: string,
    country_iso_codes: string,
    type_ids: string,
    organization_ids: string,
    order: string,
    date_range: string,
    editorial: boolean
  ) {
    return this.http.get(this.baseUrl + 'neo_projects/?page=' + page +
      '&search=' +
      search_text +
      '&username=' +
      username +
      '&disciplines=' +
      discipline_ids +
      '&type=' +
      type_ids +
      '&countries=' +
      country_iso_codes +
      '&organizations=' +
      organization_ids +
      '&ordering=' +
      order +
      '&date_range=' +
      date_range +
      '&editorial=' +
      editorial);
  }


  getFilteredImages(
    page: number,
    search_text: string,
    order: string,
    date_range: string,
    tag_ids: string,
  ) {
    return this.http.get(
      this.baseUrl +
      'neo_medias/images' +
      '/?page=' +
      page +
      '&search=' +
      search_text +
      '&ordering=' +
      order +
      '&date_range=' +
      date_range +
      '&tags=' +
      tag_ids
    );
  }
}
